function showYaMaps() {
    const mapNode = document.querySelector('#ordering-pickup-map')

    if (!mapNode.querySelector('script')) {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = 'https://api-maps.yandex.ru/2.1/?apikey=3a4315ee-7fbf-4437-88f8-3236cd2ebd58&lang=ru_RU'

        mapNode.appendChild(script)

        script.onload = function () {
            initYmap(mapNode)
        }
    }
}

function initYmap(node) {
    try {
        ymaps.ready(function () {
            let map = new ymaps.Map(node, {
                center: JSON.parse(node.getAttribute('data-center')),
                zoom: 7,
            })

            fetch(node.getAttribute('data-url'), {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json"
                },
            }).then(res => res.json()).then(data => {
                const parent = document.querySelector('.area-desc__radio')

                for (const geo of data.objects) {

                    const radio = domParser.call(radioBtnList(geo), 'li')

                    const geoObject = new ymaps.Placemark(geo.coords, {}, {
                        iconLayout: geo.iconLayout,
                        iconImageHref: geo.iconImageHref,
                        iconImageSize: geo.iconImageSize,
                        iconImageOffset: geo.iconImageOffset
                    })

                    radio.onchange = function () {
                        map.setCenter(geo.coords)
                        map.setZoom(16)

                        innerWidth >= 992 && geoObjectClickHandler(geo)
                    }

                    parent.appendChild(radio)

                    const firstRadio = parent.querySelector('.Radio-btn-default__label > input')

                    firstRadio.checked = true



                    geoObject.events.add('click', function () {
                        innerWidth >= 992 && geoObjectClickHandler(geo)
                    });

                    map.geoObjects.add(geoObject)
                }
            })
        })
    } catch (e) {
        console.log(e)
    }
}


function geoSideContent(point) {
    return `
        <div class="ymaps-geo">
            <div class="ymaps-geo__wrapper">
                <picture class="ymaps-geo__picture">
                    <source srcset="${point.imgWebp}">
                    <img src="${point.img}" alt="${point.alt}">
                </picture>
                <div class="ymaps-geo__address">
                    <span class="Icon__container">
                        <svg class="Icon Icon--theme-m">
                            <use xlink:href="#point"></use>
                        </svg>
                    </span>
                    <p class="ymaps-geo__address-text address">
                        <span class="address__street">${point.street}</span>
                        <span class="address__detail">${point.address}</span>
                    </p>
                </div>
                <div class="ymaps-geo__time">
                    <span class="Icon__container">
                        <svg class="Icon Icon--theme-m">
                            <use xlink:href="#clock"></use>
                        </svg>
                    </span>
                    <p class="ymaps-geo__time-text">${point.time}</p>
                </div>
                <div class="ymaps-geo__path">
                    <span class="Icon__container">
                        <svg class="Icon Icon--theme-m">
                            <use xlink:href="#bus"></use>
                        </svg>
                    </span>
                    <p class="ymaps-geo__path-text">${point.path}</p>
                </div>
                <span class="ymaps-geo__close Icon__container" onclick="this.closest('div').remove()">
                    <svg class="Icon Icon--theme-m">
                        <use xlink:href="#close"></use>
                    </svg>
                </span>
            </div>
        </div>
    `
}


function radioBtnList(point) {
    return `
    <li>
		<label class="Radio-btn-default__label">
			<input
				class="Radio-btn-default__input Radio-btn-default--selected"
				type="radio" name="pickup_address" value="${point.street}"
				 />
			<span class="Radio-btn-default__text">
                ${point.street}
			</span>
		</label>
	</li>
    `
}



function domParser(selector) {
    return new DOMParser().parseFromString(this, 'text/html').querySelector(selector)
}

function geoObjectClickHandler(geo) {
    // Анимация добавления и появления
    new Promise((res) => {
        const nodes = document.querySelectorAll('.ymaps-geo')

        nodes.forEach(node => {
            node.classList.remove(`${node.classList[0]}--active`)
        })

        setTimeout(() => {
            nodes.forEach(node => {
                node.remove()
            })
            res()
        }, 500)
    }).then(() => {
        const geoContent = domParser.call(geoSideContent(geo), '.ymaps-geo')
        setTimeout(() => {
            geoContent.classList.add(`${geoContent.classList[0]}--active`)
        }, 100)
        document.body.appendChild(geoContent)
    })
}